module.exports = __webpack_public_path__ + "img/image-12.3c0e8928.jpg";